import React from 'react';
import { shape, string } from 'prop-types';
import { sizes, Typography } from '@hyphengroup/cag-components';
import Heading from './Heading';
import Icon from './Icon';

const FormHeadingRegular = ({
  title,
  subTitle,
  description,
  requiredFields,
  className,
}) => (
  <div>
    <div className="layout-row">
      <div className="layout-column">
        <Heading primary as="h1" className={className}>
          {title}
        </Heading>
        { subTitle && (
          <Typography variant="secondary" as="h4" align={['left', 'left', 'right']} regular className={className} float="right" m={[0, 0, `${sizes(-5)} 0 ${sizes(5)} 0`]}>
            {subTitle}
          </Typography>
        )}
      </div>
    </div>
    <div className="layout-row">
      <div className="layout-column">
        <Heading as="h3">
          {description}
        </Heading>
      </div>
    </div>
    <div className="layout-row">
      <div className="layout-column required-field-message">
        <Icon name={requiredFields.icon} />
        {requiredFields.message}
      </div>
    </div>
  </div>
);

FormHeadingRegular.defaultProps = {
  requiredFields: { icon: '', text: '' },
  className: '',
  subTitle: '',
};

FormHeadingRegular.propTypes = {
  requiredFields: shape({
    icon: string,
    message: string,
  }),
  title: string.isRequired,
  subTitle: string,
  description: string.isRequired,
  className: string,
};

export default FormHeadingRegular;
